export const getProviderDisplayName = (provider?: string | null): string => {
  if (!provider) return "Unknown";
  
  const providerMap: Record<string, string> = {
    openai: "OpenAI",
    anthropic: "Anthropic",
    google: "Google",
    azure: "Azure OpenAI",
    cohere: "Cohere",
    meta: "Meta",
    mistral: "Mistral",
    groq: "Groq",
    replicate: "Replicate",
    huggingface: "Hugging Face",
    bedrock: "AWS Bedrock",
    vertexai: "Google Vertex AI",
  };

  return providerMap[provider.toLowerCase()] || provider;
};
